// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7f76e757","977":"c042a852"}[chunkId] + ".chunk.js";
};